/* Tiered "spend & save" — cart progress-to-next-tier.
   window.JY_TIERS = [[min,off],...] is injected by jy-tier-bar.liquid from the
   theme settings. Exposes window.JY_TIER.render(subtotalMAD) which the cart JS
   calls on every total refresh. Pure ES5 (no ?./??), updates text + a reserved
   bar inside an already-rendered slot → no old-WebView SyntaxError, no CLS. */
(function () {
  var TIERS = (window.JY_TIERS || [])
    .slice()
    .sort(function (a, b) { return a[0] - b[0]; });
  var FREE = Number(window.JY_TIER_FREESHIP || 0); /* free-shipping threshold (coincides with tier 1) */
  var isAr =
    document.documentElement.lang && document.documentElement.lang.indexOf('ar') === 0;

  function money(n) {
    return Math.round(n) + (isAr ? ' درهم' : ' Dhs');
  }

  function compute(sub) {
    if (!TIERS.length) return null;
    var cur = -1, i;
    for (i = 0; i < TIERS.length; i++) {
      if (sub >= TIERS[i][0]) cur = i;
    }
    var earned = cur >= 0 ? TIERS[cur][1] : 0;
    var next = TIERS[cur + 1];
    if (next) {
      var floor = cur >= 0 ? TIERS[cur][0] : 0;
      var span = next[0] - floor;
      var pct = span > 0 ? ((sub - floor) / span) * 100 : 0;
      return {
        top: false,
        earned: earned,
        remaining: Math.max(0, next[0] - sub),
        nextOff: next[1],
        pct: Math.max(4, Math.min(100, pct)),
      };
    }
    return { top: true, earned: earned, remaining: 0, nextOff: 0, pct: 100 };
  }

  var topMin = TIERS.length ? TIERS[TIERS.length - 1][0] : 0;

  window.JY_TIER = {
    render: function (sub) {
      var box = document.querySelector('[data-jy-tierprog]');
      if (!box) return;
      var c = compute(sub);
      if (!c || sub <= 0) { box.hidden = true; return; }
      box.hidden = false;
      /* absolute fill (0 → top tier) so the milestone dots line up */
      var fill = box.querySelector('[data-jy-tierprog-fill]');
      var absPct = topMin > 0 ? Math.max(3, Math.min(100, (sub / topMin) * 100)) : 0;
      if (fill) fill.style.width = absPct + '%';
      /* check off every threshold already reached */
      var marks = box.querySelectorAll('[data-jy-mark]');
      for (var m = 0; m < marks.length; m++) {
        var mv = parseFloat(marks[m].getAttribute('data-jy-mark')) || 0;
        marks[m].className = sub >= mv ? 'jy-tierprog__mark is-hit' : 'jy-tierprog__mark';
      }
      box.className = c.top ? 'jy-tierprog is-max' : 'jy-tierprog';
      var msg = box.querySelector('[data-jy-tierprog-msg]');
      if (!msg) return;
      if (c.top) {
        msg.innerHTML =
          (isAr ? '🎉 وصلتي لأقصى خصم · وفّرتي ' : '🎉 Remise maximale · vous économisez ') +
          '<b>' + money(c.earned) + '</b>';
      } else {
        var pre = c.earned > 0
          ? (isAr ? 'وفّرتي ' + money(c.earned) + ' · ' : 'Vous économisez ' + money(c.earned) + ' · ')
          : '';
        /* free shipping unlocks at FREE (same milestone as tier 1) — fold it into
           the reward for the tier that crosses it, so 250 reads as "free delivery
           + −50 Dhs" instead of just a discount. Doubles the perceived value. */
        var freeAtNext = FREE > 0 && sub < FREE && (sub + c.remaining) >= FREE;
        msg.innerHTML = '🎁 ' + pre + (isAr
          ? 'زوّد <b>' + money(c.remaining) + '</b> وتربح ' + (freeAtNext ? '🚚 توصيل مجاني + ' : '') + 'خصم <b>' + money(c.nextOff) + '</b>'
          : 'Ajoutez <b>' + money(c.remaining) + '</b> pour ' + (freeAtNext ? '🚚 livraison offerte + ' : '') + '<b>' + money(c.nextOff) + '</b> de remise');
      }
    },
  };
})();
